import { publicClient, privateClient } from './client';
import { UserContext } from './UserContext';

const transactionsUserContext = (pub: boolean) => new UserContext(pub ? publicClient : privateClient);
export default transactionsUserContext;
